interface Props {
  readonly label?: string;
}

export function LoadingState({ label = "Loading…" }: Props) {
  return (
    <div className="flex h-full min-h-[40vh] items-center justify-center" role="status" aria-live="polite">
      <div className="flex items-center gap-3" style={{ color: "var(--fg-muted)" }}>
        <Spinner />
        <span className="text-sm">{label}</span>
      </div>
    </div>
  );
}

function Spinner() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden style={{ color: "var(--accent)" }}>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.2" strokeWidth="2.5" />
      <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
        <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="900ms" repeatCount="indefinite" />
      </path>
    </svg>
  );
}
